import React, { useState } from "react";
import { Marquee } from "../components/Marquee";
import { ProjectViewer } from "../components/work/ProjectViewer";
import { ScrollTimecode } from "../components/ScrollTimecode";
import { SiteFooter } from "../components/SiteFooter";
import { SiteNavigation } from "../components/SiteNavigation";
import { AboutSection } from "../components/home/AboutSection";
import { BrandsSection } from "../components/home/BrandsSection";
import { ContactSection } from "../components/home/ContactSection";
import { FaqSection } from "../components/home/FaqSection";
import { HeroSection } from "../components/home/HeroSection";
import { SkillsSection } from "../components/home/SkillsSection";
import { TestimonialsSection } from "../components/home/TestimonialsSection";
import { WhatIDoBest } from "../components/home/services/WhatIDoBest";
import { WorkSection } from "../components/home/WorkSection";
import { toolTicker } from "../data/media";
import type { WorkItem } from "../types/work";
export function HomePage() {
  const [viewer, setViewer] = useState<WorkItem | null>(null);
  return <div id="top" className="min-h-screen w-full [overflow-x:clip] bg-[#050808] text-white selection:bg-[#54f6c6] selection:text-[#05100d]" data-id="element-586" data-mp="2eporfox5oko3">
      <ScrollTimecode data-id="element-587" data-mp="2jhynlmov6gyt" />
      <SiteNavigation data-id="element-588" data-mp="2og9ze2ypz1jo" />

      <main data-id="element-589" data-mp="2ogt9wym1inno">
        <HeroSection data-id="element-590" data-mp="2of8dt4k2uwnp" />
        <BrandsSection data-id="element-591" data-mp="2ofrs8bair2wz" />
        <WhatIDoBest data-id="element-592" data-mp="2oi490l4jj78g" />

        <div className="border-y border-white/10 bg-[#050808] py-6" data-id="element-593" data-mp="1rqajfng8p0r2">
          <Marquee items={toolTicker} data-id="element-594" data-mp="1rsdgusjq1w5t" />
        </div>

        <WorkSection onOpen={setViewer} data-id="element-595" data-mp="1vsnjpwc7w6gg" />
        <AboutSection data-id="element-596" data-mp="1vtp0mhfwzn63" />
        <SkillsSection data-id="element-597" data-mp="20qyvwdpzit1u" />
        <TestimonialsSection data-id="element-598" data-mp="20qfldi2nz6xu" />
        <FaqSection data-id="element-599" data-mp="20pe06krxp42e" />
        <ContactSection data-id="element-600" data-mp="20t1u3l1ajshn" />
      </main>

      <SiteFooter data-id="element-601" data-mp="25q20jx21yx9a" />
      <ProjectViewer item={viewer} onClose={() => setViewer(null)} onNavigate={setViewer} data-id="element-602" data-mp="25ql7kiq6018j" />
    </div>;
}